import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'
import { DOC_FLOW_FORM_FINAL_NAME_FIELD_MAX_LENGTH } from '../DocFlow.constants'

export function isLimitExceed(documentTitle, variableValue) {
  return (
    documentTitle.length + variableValue.label.length >
    DOC_FLOW_FORM_FINAL_NAME_FIELD_MAX_LENGTH
  )
}

export function getDocFlowVariableFieldValueProps() {
  return {
    value: FORMIK_EMPTY_VALUE,
  }
}
